export default "__VITE_ASSET__d702aac8__"